<template>
    <app-layout title="Odeslané zprávy">

        <MessagesTable v-if="messages.length > 0" type="sent" :messages="messages" @refreshMessages="refreshMessages"/>

        <MessagesTableNoMessages v-else/>

        <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { Link } from '@inertiajs/inertia-vue3'
import { useToast } from "vue-toastification";
import MessagesTable from "../Components/MessagesTable";
import MessagesTableNoMessages from "../Components/MessagesTableNoMessages";

export default {
    components: {
        MessagesTableNoMessages,
        MessagesTable,
        AppLayout,
        InertiaLink: Link,
    },
    data() {
        return {
            statuses: this.$page.props.statuses,
            messages: this.$page.props.messages,
            lastUpdate: this.$page.props.lastUpdate,
            page: this.$page.props.page,
            search: this.$page.props.search,
            maxPage: this.$page.props.maxPage,

            activePage: this.$page.props.activePage,
            settings: this.$page.props.settings,

            refreshMessagesInterval: null,

            showMessageOptions: null,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    mounted(){
        this.setUpEcho();
    },
    unmounted(){
        this.destroyEcho();
    },

    methods: {
        setUpEcho(){
            console.log('setup up echo sent')
            Echo.private('App.Models.User.' + this.$page.props.user.id)
                .listen('MessagesChanged', (e) => {
                    console.log('MessagesChanged', e);
                    this.refreshMessages();
                })
        },
        destroyEcho(){
            console.log('destroy echo sent')
            Echo.leave('App.Models.User.'+this.$page.props.user.id);
        },
        refreshMessages(){
            axios.get(route('fapi.messages', {direction: 2, page: this.page, search: this.search, manual: 0, longterm: this.activePage === 'longtermsent' ? 1 : 0}))
                .then(response => {
                    if(response.status === 200){
                        this.messages = response.data.messages;
                        this.lastUpdate = response.data.lastUpdate;
                    }
                });
        },
        deleteMessage(msgId){
            axios.delete(route('fapi.delete', msgId))
                .then(response => {
                    if(response.status === 200)
                        this.toast.success(response.data.message)

                    this.refreshMessages();
                });
        },
        markUnread(msgId){
            axios.post(route('fapi.unread', msgId))
                .then(response => {
                    if(response.status === 200)
                        this.toast.success(response.data.message)

                    this.refreshMessages();
                });
        },
        markRead(msgId){
            axios.post(route('fapi.read', msgId))
                .then(response => {
                    if(response.status === 200)
                        this.toast.success(response.data.message)

                    this.refreshMessages();
                });
        },
        previousPage(){
            if(this.activePage === 'sent') if(this.page > 0) this.$inertia.visit(route('sent', {page: parseInt(this.page) - 1}));
            if(this.activePage === 'longtermsent') if(this.page > 0) this.$inertia.visit(route('longtermsent', {page: parseInt(this.page) - 1}));
        },
        nextPage(){
            if(this.activePage === 'sent') if(this.page < this.maxPage) this.$inertia.visit(route('sent', {page: parseInt(this.page) + 1}));
            if(this.activePage === 'longtermsent') if(this.page < this.maxPage) this.$inertia.visit(route('longtermsent', {page: parseInt(this.page) + 1}));
        },
        showDeliveryInfo(id){
            if(id == null) return;
            this.$inertia.visit(route('viewDeliveryInfo', {id: id}));
        }

    },
    computed: {
        lastUpdateText: function() {
            let datetime = new Date(this.lastUpdate);
            return datetime.toLocaleDateString() + ', ' + datetime.toLocaleTimeString();
        },
    }
}
</script>

